import { LabelVariantsWrapper } from "./styles"
interface ILabelVariantsProps {
	label: string
	withbadge?: boolean
	status: "green" | "yellow" | "blue" | "purple" | "orange"
}
export default function LabelVariants({
	label,
	withbadge = false,
	status,
}: ILabelVariantsProps) {
	return (
		<LabelVariantsWrapper status={status}>
			<div>
				{withbadge && <span className='badg'></span>}
				<span className='label'>{label}</span>
			</div>
		</LabelVariantsWrapper>
	)
}
